import { ROUTES } from 'src/components/app/app-routes.constants';

export const getPath = (path: string) => {
  if (path.includes(ROUTES.customers)) {
    return ROUTES.customers;
  }
  if (path.includes(ROUTES.employee)) {
    return ROUTES.employee;
  }
  if (path.includes(ROUTES.project)) {
    return ROUTES.project;
  }

  return path;
};
